import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import particle1 from "../../utils/particles";

const ParticlesComponent = () => {
  const handleInit = async (data) => {
    await loadFull(data);
  };
  return <Particles id="particles" options={particle1} init={handleInit} />;
};
export default ParticlesComponent;
